import { render } from "./VersionSwitch.vue?vue&type=template&id=c68aae9c&ts=true"
import script from "./VersionSwitch.vue?vue&type=script&lang=ts"
export * from "./VersionSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__